import { dataFourQuarterCircles } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFourQuarterCircles = /*#__PURE__*/createIcon(dataFourQuarterCircles)
export default IconFourQuarterCircles
